import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]
  static values = { userId: String, inloopId: String }

  get persistKey() {
    return `inloop-${this.inloopIdValue}-participant-${this.userIdValue}-expanded`
  }

  connect() {
    const saved = localStorage.getItem(this.persistKey)
    this.expanded = saved === "true"
    this.applyExpandedState()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.expanded = !this.expanded
    localStorage.setItem(this.persistKey, this.expanded)
    this.applyExpandedState()
  }

  applyExpandedState() {
    // Find all child items for this user (both table rows and mobile card divs)
    const userId = this.userIdValue

    // For desktop table: find child rows in tbody
    const tbody = this.element.tagName === 'TR' ? this.element.parentElement : null
    const childRows = tbody ? tbody.querySelectorAll(`tr[data-parent-user-id="${userId}"]`) : []

    // For mobile cards: find child divs within the same card
    const childDivs = this.element.querySelectorAll(`div[data-parent-user-id="${userId}"]`)

    // Toggle visibility for both rows and divs
    const allChildren = [...childRows, ...childDivs]
    allChildren.forEach(child => {
      if (this.expanded) {
        child.classList.remove("hidden")
      } else {
        child.classList.add("hidden")
      }
    })

    // Rotate chevron icon
    if (this.hasIconTarget) {
      if (this.expanded) {
        this.iconTarget.style.transform = "rotate(90deg)"
      } else {
        this.iconTarget.style.transform = "rotate(0deg)"
      }
    }
  }
}
